<template>
  <div v-if="list" class="lc-list">
    <CardTabledList>
      <tr v-for="(item, i) in list" :key="i">
        <td>{{ item.label }}</td>
        <td>
          <div class="d-inline-flex">
            <div>{{ item.content }}</div>
            <div v-if="item.canCopy" class="ml-1">
              <CopyToClipboard :text="item.content.toString()" />
            </div>
            <ActionIcons v-if="item.actions" :actions="item.actions" class="ml-2" />
          </div>
        </td>
      </tr>
    </CardTabledList>
  </div>
</template>

<script>
import ActionIcons from "@/components/display/ActionIcons";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import CopyToClipboard from "@/components/display/CopyToClipboard";

export default {
  name: "CardListContent",
  components: {
    ActionIcons,
    CardTabledList,
    CopyToClipboard,
  },
  props: {
    list: Array,
    actions: {
      type: Array,
      default: () => [],
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.lc-list {
  table {
    width: auto;
  }
  tbody {
    td {
      &:first-of-type {
        max-width: 100%;
        white-space: nowrap;
      }
    }
    tr {
      td {
        padding-bottom: 0.25rem;
        border: none;
        font-weight: bold;

        &:last-of-type {
          font-weight: normal;
          text-align: start;
          vertical-align: bottom;
          word-break: break-all;
        }
        &:first-of-type {
          padding-left: 0;
          padding-right: 2rem;
          font-size: 1rem;
        }
      }
    }
  }
}
</style>
